exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-hidden {\r\n    visibility: hidden;\r\n}\r\n.loader-overlay {\r\n    position: absolute;\r\n    width:100%;\r\n    top:0;\r\n    left: 0;\r\n    opacity: 1;\r\n    z-index: 500000;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/loader/loader.component.css
// module id = 2296
// module chunks = 1